<div>
  <div class="rephrase-box">
    <div class="rephrase-fields">
      <div class="sourceText">
        <mat-form-field class="invisible-field">
          <mat-label>&nbsp;</mat-label>
          <mat-select>
          </mat-select>
        </mat-form-field>
        <textarea class="form-control" type="text" title="Input field" [(ngModel)]="textToRephrase" [placeholder]="'Text.EnterText' | translate"></textarea>
      </div>
      <div class="targetText">
        <mat-form-field>
          <mat-label>{{'FileUpload.Languages' | translate }}</mat-label>
          <mat-select [(ngModel)]="selectedRephraseLanguage">
            @for (key of rephraseLanguages | async | keyvalue; track key) {
              <mat-option [value]="key.value">
                {{key.key}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <textarea class="form-control" type="text" #copyText title="Output field" [readOnly]="true" [value]="rephrasedText"></textarea>
        <div class="copyButton">
          <button (click)="copyToClipboard()" class="btn btn-secondary btn-lg" type="button" title="Copy to clipboard"><i class="bi bi-clipboard"></i></button>
        </div>
      </div>
    </div>
    <div class="rephraseButton">
      <button class="btn btn-primary" type="button" (click)="rephraseString()">{{'NavBar.Rephrase' | translate}}</button>
    </div>
    <div class="rephraseOptions">
      <app-rephrase-options></app-rephrase-options>
    </div>
  </div>
</div>